
import Vue from "vue";
import { BrowseStateBase } from "@/utils/browse/browse-state-base";

export default Vue.extend({
	props: {
		item: {
			type: Object as () => any,
			required: true
		},
		state: {
			type: Object as () => BrowseStateBase,
			required: true
		}
	},
	computed: {
		loaded():boolean {
			return this.state.sidebarItemLoaded;
		},
		documents():any[] {
			let docs:any[] = this.item.AWSDocuments || [];
			return docs.filter(d=>d && d.File && d.getUrl);
		},
		summary():string {
			if (this.documents.length == 0) return "";
			return this.$ctc("sidebar.attachments.count", this.documents.length, {count: this.documents.length}).toString();
		}
	},
	watch: {
		summary: {
			immediate: true,
			handler(){
				this.$emit("summary", this.summary);
			}
		},
		item(){
			this.$emit("summary", this.summary);
		}
	},
	methods: {
		iconFor(doc:any):string {
			let name = (doc.getName() || "").toLowerCase();
			if (name.endsWith(".pdf")) return "file-pdf";
			if (/\.(png|jpe?g|gif|webp)$/.test(name)) return "file-image";
			if (/\.(xlsx?|csv)$/.test(name)) return "file-excel";
			if (/\.docx?$/.test(name)) return "file-word";
			return "file";
		}
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
